(function () {
  'use strict';

  try {
    window.sessionStorage.setItem('tw_recs_collapsed', '1');
  } catch (error) {
    // The drawer still works when storage is unavailable.
  }

  var style = document.createElement('style');
  style.id = 'tw-cart-hotfix-20260729';
  style.textContent = [
    '.m-cart-drawer.tw-drawer{touch-action:pan-y!important;}',
    '.m-cart-drawer.tw-drawer .tw-drawer__inner{min-height:0!important;touch-action:pan-y!important;}',
    '.m-cart-drawer.tw-drawer .tw-drawer__body{min-height:0!important;overflow-y:auto!important;overflow-x:hidden!important;touch-action:pan-y!important;overscroll-behavior-y:contain!important;-webkit-overflow-scrolling:touch!important;}',
    '.m-cart-drawer.tw-drawer .tw-qty .m-quantity__button{position:relative!important;inset:auto!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;line-height:0!important;}',
    '.m-cart-drawer.tw-drawer .tw-qty .m-quantity__button::after{content:none!important;display:none!important;pointer-events:none!important;}',
    '.m-cart-drawer.tw-drawer .tw-qty .m-quantity__button svg{position:static!important;display:block!important;width:8px!important;height:8px!important;margin:0!important;transform:none!important;}',
    '.m-cart-drawer.tw-drawer .tw-qty .m-quantity__input{display:block!important;height:var(--tw-qty-h)!important;line-height:var(--tw-qty-h)!important;padding:0!important;margin:0!important;text-align:center!important;}',
    '.m-cart-drawer.tw-drawer .tw-line{align-items:stretch!important;}',
    '.m-cart-drawer.tw-drawer .tw-line__media{align-self:stretch!important;}',
    '.m-cart-drawer.tw-drawer .tw-line__body{align-self:stretch!important;min-height:var(--tw-media-h)!important;}',
    '.m-cart-drawer.tw-drawer .tw-line__bottom{width:100%!important;min-height:24px!important;margin-top:auto!important;padding-top:8px!important;align-items:center!important;}',
    '.m-cart-drawer.tw-drawer .tw-line__actions{align-items:center!important;}',
    '.m-cart-drawer.tw-drawer .tw-qty{align-items:stretch!important;vertical-align:bottom!important;}',
    '.m-cart-drawer.tw-drawer .tw-reserve{position:static!important;inset:auto!important;z-index:auto!important;display:flex!important;flex:0 0 auto!important;align-items:center!important;justify-content:center!important;gap:5px!important;width:100%!important;min-height:32px!important;padding:8px var(--tw-pad)!important;margin:0!important;background:#0a0a0a!important;color:#ff3131!important;border:0!important;font-size:11px!important;font-weight:700!important;line-height:1.2!important;text-align:center!important;text-transform:uppercase!important;white-space:nowrap!important;box-sizing:border-box!important;pointer-events:none!important;overflow-anchor:none!important;}',
    '.m-cart-drawer.tw-drawer .tw-reserve__time{display:inline-block;min-width:31px;font-variant-numeric:tabular-nums;font-feature-settings:"tnum" 1;text-align:left;color:#ff3131!important;}',
    '.m-cart-drawer.tw-drawer.m-cart--empty .tw-reserve{display:none!important;}'
  ].join('');
  (document.body || document.documentElement).appendChild(style);

  var RESERVE_DURATION = 10 * 60 * 1000;
  var END_KEY = 'tw_cart_reserve_until_v1';
  var SIGNATURE_KEY = 'tw_cart_reserve_signature_v1';
  var memoryEnd = 0;
  var memorySignature = '';
  var observer = null;
  var syncFrame = 0;

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, String(value));
    } catch (error) {
      // Memory fallback is handled separately.
    }
  }

  function removeStorage(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      // Nothing else to do.
    }
  }

  function clearReservation() {
    memoryEnd = 0;
    memorySignature = '';
    removeStorage(END_KEY);
    removeStorage(SIGNATURE_KEY);
  }

  function getDrawer() {
    return document.querySelector('.m-cart-drawer.tw-drawer');
  }

  function getScrollBody(drawer) {
    return drawer ? drawer.querySelector('.tw-drawer__body') : null;
  }

  function getCartSignature(drawer) {
    var count = drawer.querySelector('[data-tw-cart-count]');
    var subtotal = drawer.querySelector('[data-cart-subtotal-price]');
    var titles = Array.prototype.map.call(
      drawer.querySelectorAll('.tw-line__title'),
      function (element) {
        return element.textContent.trim();
      }
    ).join('|');

    return [
      count ? count.textContent.trim() : '',
      subtotal ? subtotal.textContent.trim() : '',
      titles
    ].join('::');
  }

  function getReservationEnd(signature) {
    var storedSignature = readStorage(SIGNATURE_KEY) || memorySignature;
    var storedEnd = Number(readStorage(END_KEY) || memoryEnd || 0);

    if (!storedEnd || storedSignature !== signature) {
      storedEnd = Date.now() + RESERVE_DURATION;
      storedSignature = signature;
      memoryEnd = storedEnd;
      memorySignature = storedSignature;
      writeStorage(END_KEY, storedEnd);
      writeStorage(SIGNATURE_KEY, storedSignature);
    }

    return storedEnd;
  }

  function recommendationsShouldBeCollapsed() {
    try {
      return window.sessionStorage.getItem('tw_recs_collapsed') === '1';
    } catch (error) {
      return true;
    }
  }

  function applyRecommendationState() {
    if (!recommendationsShouldBeCollapsed()) return;

    var recommendations = document.querySelector('[data-tw-recs]');
    if (!recommendations) return;

    recommendations.classList.remove('is-open');
    var toggle = recommendations.querySelector('[data-tw-recs-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function ensureReserveBanner(drawer) {
    if (!drawer) return { banner: null, inserted: false };

    if (drawer.classList.contains('m-cart--empty')) {
      var existingEmptyBanner = drawer.querySelector('[data-tw-cart-reserve]');
      if (existingEmptyBanner) existingEmptyBanner.remove();
      clearReservation();
      return { banner: null, inserted: false };
    }

    var shipSlot = drawer.querySelector('.tw-drawer__body > .tw-ship-slot');
    if (!shipSlot || !shipSlot.parentNode) {
      return { banner: null, inserted: false };
    }

    var banner = drawer.querySelector('[data-tw-cart-reserve]');
    if (banner) return { banner: banner, inserted: false };

    banner = document.createElement('div');
    banner.className = 'tw-reserve';
    banner.setAttribute('data-tw-cart-reserve', '');
    banner.innerHTML = '<span class="tw-reserve__label">YOUR BAG IS RESERVED FOR</span><span class="tw-reserve__time" data-tw-cart-reserve-time role="timer">10:00</span>';
    shipSlot.parentNode.insertBefore(banner, shipSlot);

    return { banner: banner, inserted: true };
  }

  function restoreScrollAfterInsertion(scrollBody, scrollTop) {
    if (!scrollBody || scrollTop <= 0) return;

    window.requestAnimationFrame(function () {
      if (!scrollBody.isConnected) return;
      if (Math.abs(scrollBody.scrollTop - scrollTop) > 1) {
        scrollBody.scrollTop = scrollTop;
      }
    });
  }

  function renderReservation() {
    var drawer = getDrawer();
    if (!drawer) return;

    var scrollBody = getScrollBody(drawer);
    var scrollTop = scrollBody ? scrollBody.scrollTop : 0;
    var state = ensureReserveBanner(drawer);
    var banner = state.banner;

    if (!banner) return;
    if (state.inserted) restoreScrollAfterInsertion(scrollBody, scrollTop);

    var signature = getCartSignature(drawer);
    var end = getReservationEnd(signature);
    var remaining = Math.max(0, end - Date.now());
    var totalSeconds = Math.ceil(remaining / 1000);
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    var label = banner.querySelector('.tw-reserve__label');
    var timer = banner.querySelector('[data-tw-cart-reserve-time]');

    if (!label || !timer) return;

    if (remaining <= 0) {
      if (label.textContent !== 'BAG RESERVATION ENDED') {
        label.textContent = 'BAG RESERVATION ENDED';
      }
      if (timer.textContent !== '') timer.textContent = '';
      timer.hidden = true;
      banner.classList.add('is-expired');
      return;
    }

    var nextTime = String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');

    if (label.textContent !== 'YOUR BAG IS RESERVED FOR') {
      label.textContent = 'YOUR BAG IS RESERVED FOR';
    }
    timer.hidden = false;
    if (timer.textContent !== nextTime) timer.textContent = nextTime;
    banner.classList.remove('is-expired');
  }

  function scheduleDrawerSync() {
    if (syncFrame) return;

    syncFrame = window.requestAnimationFrame(function () {
      syncFrame = 0;
      applyRecommendationState();
      renderReservation();
    });
  }

  function mutationIsOutsideBanner(mutation) {
    var target = mutation.target && mutation.target.nodeType === 1
      ? mutation.target
      : mutation.target && mutation.target.parentElement;

    return !(target && target.closest('[data-tw-cart-reserve]'));
  }

  function observeDrawer() {
    var drawer = getDrawer();
    if (!drawer || observer) return;

    observer = new MutationObserver(function (mutations) {
      if (!mutations.some(mutationIsOutsideBanner)) return;
      scheduleDrawerSync();
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }

  function subscribeToCartEvents() {
    if (!window.MinimogEvents || !window.MinimogTheme) return;

    var events = window.MinimogTheme.pubSubEvents || {};
    if (events.cartUpdate) {
      window.MinimogEvents.subscribe(events.cartUpdate, scheduleDrawerSync);
    }
    if (events.openCartDrawer) {
      window.MinimogEvents.subscribe(events.openCartDrawer, scheduleDrawerSync);
    }
  }

  function init() {
    applyRecommendationState();
    renderReservation();
    observeDrawer();
    subscribeToCartEvents();
    window.setInterval(renderReservation, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Mobile-only MY BAG toolbar and coupon panel on the standalone cart page. */
(function () {
  'use strict';

  var busy = false;

  function cartRoot() {
    return document.querySelector('[data-tw-cart-page]');
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function fetchCart() {
    return fetch(shopRoot() + 'cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }

  function postJSON(path, body) {
    return fetch(shopRoot() + path, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.text().then(function (text) {
        var data = null;
        try { data = text ? JSON.parse(text) : null; } catch (error) {}
        if (!response.ok) {
          throw new Error((data && (data.description || data.message)) || text || 'Cart update failed');
        }
        return data;
      });
    });
  }

  function appliedCodes(cart) {
    return (cart.discount_codes || []).filter(function (discount) {
      if (!discount || !discount.code) return false;
      if (discount.applied === false || discount.applicable === false) return false;
      return true;
    });
  }

  function codeList(cart) {
    return appliedCodes(cart).map(function (discount) {
      return String(discount.code);
    });
  }

  function findCode(cart, code) {
    var target = String(code || '').toUpperCase();
    return (cart.discount_codes || []).filter(function (discount) {
      return discount && String(discount.code || '').toUpperCase() === target;
    })[0] || null;
  }

  function domItemCount(root) {
    var count = 0;
    root.querySelectorAll('.tw-cart-page__line .m-quantity__input').forEach(function (input) {
      var value = parseInt(input.value, 10);
      count += Number.isFinite(value) ? value : 0;
    });
    return count;
  }

  function installMobileStyles() {
    if (document.getElementById('tw-cart-mobile-toolbar-styles-20260730')) return;

    var style = document.createElement('style');
    style.id = 'tw-cart-mobile-toolbar-styles-20260730';
    style.textContent = [
      '[data-tw-cart-page] .tw-cart-mobile-tools,[data-tw-cart-page] .tw-cart-mobile-coupon{display:none!important;}',
      '@media screen and (max-width:899px){',
        '[data-tw-cart-page] .tw-cart-mobile-tools{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:14px!important;min-height:58px!important;padding:0 18px!important;box-sizing:border-box!important;background:#fff!important;border:0!important;box-shadow:none!important;}',
        '[data-tw-cart-page].m-cart--empty .tw-cart-mobile-tools{display:none!important;}',
        '[data-tw-cart-page] .tw-cart-mobile-title{display:inline-flex!important;align-items:center!important;gap:5px!important;margin:0!important;color:#0a0a0a!important;font-size:18px!important;font-weight:800!important;line-height:1!important;letter-spacing:-.5px!important;text-transform:uppercase!important;white-space:nowrap!important;}',
        '[data-tw-cart-page] .tw-cart-mobile-count{display:inline-flex!important;align-items:center!important;margin:0!important;color:#8a8a8a!important;font-size:13px!important;font-weight:650!important;line-height:1!important;letter-spacing:-.5px!important;}',
        '[data-tw-cart-page] .tw-cart-mobile-coupon-toggle{position:relative!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:7px!important;min-height:34px!important;margin:0!important;padding:0 14px!important;border:1px solid #0a0a0a!important;border-radius:999px!important;background:#0a0a0a!important;color:#fff!important;box-shadow:none!important;font:inherit!important;font-size:11px!important;font-weight:800!important;line-height:1!important;letter-spacing:-.5px!important;text-transform:uppercase!important;white-space:nowrap!important;cursor:pointer!important;}',
        '[data-tw-cart-page] .tw-cart-mobile-coupon-toggle svg{display:block!important;width:13px!important;height:13px!important;color:#fff!important;stroke:currentColor!important;}',
        '[data-tw-cart-page] .tw-cart-mobile-code-badge[hidden]{display:none!important;}',
        '[data-tw-cart-page] .tw-cart-mobile-code-badge:not([hidden]){position:absolute!important;top:-7px!important;right:-7px!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;min-width:18px!important;height:18px!important;padding:0 4px!important;border:2px solid #fff!important;border-radius:999px!important;background:#e00000!important;color:#fff!important;box-sizing:border-box!important;font-size:10px!important;font-weight:800!important;line-height:1!important;}',
        '[data-tw-cart-page] .tw-cart-mobile-coupon{padding:0 18px 14px!important;background:#fff!important;border:0!important;}',
        '[data-tw-cart-page] .tw-cart-mobile-coupon.is-open{display:block!important;}',
        '[data-tw-cart-page] .tw-cart-mobile-coupon-inner{width:100%!important;margin:0!important;}',
        '[data-tw-cart-page] .tw-cart-mobile-coupon .tw-discount__row{width:100%!important;}',
        '[data-tw-cart-page] .tw-cart-mobile-coupon .tw-codes{margin-top:10px!important;}',
        '[data-tw-cart-page] .tw-cart-mobile-coupon.is-loading{opacity:.65!important;pointer-events:none!important;}',
      '}',
      '@media screen and (max-width:359px){',
        '[data-tw-cart-page] .tw-cart-mobile-tools{gap:10px!important;padding-left:14px!important;padding-right:14px!important;}',
        '[data-tw-cart-page] .tw-cart-mobile-title{font-size:17px!important;}',
        '[data-tw-cart-page] .tw-cart-mobile-coupon-toggle{padding-left:11px!important;padding-right:11px!important;font-size:10.5px!important;}',
      '}'
    ].join('');

    (document.head || document.documentElement).appendChild(style);
  }

  function createMobileUI(root) {
    var existing = root.querySelector('[data-tw-mobile-toolbar]');
    if (existing) return existing;

    var main = root.querySelector('.tw-cart-page__main');
    var shipping = main && main.querySelector('.tw-cart-page__shipping');
    if (!main || !shipping) return null;

    var toolbar = document.createElement('div');
    toolbar.className = 'tw-cart-mobile-tools';
    toolbar.setAttribute('data-tw-mobile-toolbar', '');

    var title = document.createElement('p');
    title.className = 'tw-cart-mobile-title';
    title.innerHTML = 'MY BAG <span class="tw-cart-mobile-count">(<span data-tw-page-count>' + domItemCount(root) + '</span>)</span>';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'tw-cart-mobile-coupon-toggle';
    button.setAttribute('data-tw-mobile-coupon-toggle', '');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Apply coupon');
    button.innerHTML = '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M1.3 5.5V3.6a.8.8 0 0 1 .8-.8h9.8a.8.8 0 0 1 .8.8v1.9a1.5 1.5 0 0 0 0 3v1.9a.8.8 0 0 1-.8.8H2.1a.8.8 0 0 1-.8-.8V8.5a1.5 1.5 0 0 0 0-3z" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round"/><path d="M5.6 5.1v3.8" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-dasharray=".9 1.5"/></svg><span>Apply coupon</span><span class="tw-cart-mobile-code-badge" data-tw-mobile-code-count hidden>0</span>';

    var panel = document.createElement('div');
    panel.className = 'tw-cart-mobile-coupon';
    panel.setAttribute('data-tw-mobile-coupon', '');
    panel.innerHTML = '<div class="tw-cart-mobile-coupon-inner"><div class="tw-discount__row"><input class="tw-discount__input" type="text" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="Enter code" aria-label="Enter code" data-tw-mobile-coupon-input><button type="button" class="tw-discount__btn" data-tw-mobile-coupon-apply>Apply</button></div><ul class="tw-codes" data-tw-mobile-code-list hidden></ul><p class="tw-discount__msg" data-tw-mobile-coupon-message hidden></p></div>';

    toolbar.appendChild(title);
    toolbar.appendChild(button);
    main.insertBefore(toolbar, shipping);
    main.insertBefore(panel, shipping);
    return toolbar;
  }

  function setOpen(root, open) {
    var panel = root.querySelector('[data-tw-mobile-coupon]');
    var button = root.querySelector('[data-tw-mobile-coupon-toggle]');
    if (!panel || !button) return;

    panel.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (open) {
      var input = panel.querySelector('[data-tw-mobile-coupon-input]');
      if (input) window.setTimeout(function () { input.focus(); }, 0);
    }
  }

  function showMessage(panel, message) {
    var element = panel.querySelector('[data-tw-mobile-coupon-message]');
    if (!element) return;
    element.textContent = message;
    element.hidden = false;
  }

  function clearMessage(panel) {
    var element = panel.querySelector('[data-tw-mobile-coupon-message]');
    if (!element) return;
    element.textContent = '';
    element.hidden = true;
  }

  function renderCart(cart) {
    var root = cartRoot();
    if (!root) return;

    var addon = parseInt(root.getAttribute('data-addon-variant-id'), 10) || 0;
    var itemCount = 0;
    (cart.items || []).forEach(function (item) {
      if (Number(item.variant_id) !== addon) itemCount += item.quantity;
    });

    root.querySelectorAll('[data-tw-page-count]').forEach(function (element) {
      element.textContent = itemCount;
    });

    var codes = appliedCodes(cart);
    root.querySelectorAll('[data-tw-mobile-code-count]').forEach(function (badge) {
      badge.textContent = codes.length;
      badge.hidden = codes.length === 0;
    });

    var list = root.querySelector('[data-tw-mobile-code-list]');
    if (!list) return;

    if (!codes.length) {
      list.innerHTML = '';
      list.hidden = true;
      return;
    }

    list.innerHTML = codes.map(function (discount) {
      var code = escapeHTML(discount.code);
      return '<li class="tw-code"><span>' + code + '</span><button type="button" class="tw-code__x" data-tw-mobile-code-remove="' + code + '" aria-label="Remove code ' + code + '"><svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1 1l10 10M11 1 1 11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button></li>';
    }).join('');
    list.hidden = false;
  }

  function syncCart() {
    fetchCart().then(renderCart).catch(function () {});
  }

  function applyCoupon(panel) {
    if (busy) return;

    var input = panel.querySelector('[data-tw-mobile-coupon-input]');
    var code = String((input && input.value) || '').trim();
    if (!code) return;

    busy = true;
    panel.classList.add('is-loading');
    clearMessage(panel);

    fetchCart()
      .then(function (cart) {
        if (!(cart.items || []).length) {
          showMessage(panel, 'Add something to your bag first.');
          return null;
        }

        var keep = codeList(cart).filter(function (existing) {
          return existing.toUpperCase() !== code.toUpperCase();
        });
        return postJSON('cart/update.js', { discount: keep.concat(code).join(',') });
      })
      .then(function (result) {
        if (result === null) return null;
        return fetchCart();
      })
      .then(function (cart) {
        if (!cart) return;
        renderCart(cart);

        var entry = findCode(cart, code);
        var applied = entry && entry.applied !== false && entry.applicable !== false;
        if (!applied) {
          showMessage(panel, entry ? 'This code does not apply to the items in your bag.' : 'That code does not exist or has expired.');
          return;
        }

        if (input) input.value = '';
        clearMessage(panel);
        window.location.reload();
      })
      .catch(function (error) {
        showMessage(panel, error.message || 'The code could not be applied.');
      })
      .finally(function () {
        busy = false;
        panel.classList.remove('is-loading');
      });
  }

  function removeCoupon(panel, code) {
    if (busy) return;

    busy = true;
    panel.classList.add('is-loading');
    var target = String(code || '').toUpperCase();

    fetchCart()
      .then(function (cart) {
        var keep = codeList(cart).filter(function (existing) {
          return existing.toUpperCase() !== target;
        });
        return postJSON('cart/update.js', { discount: keep.join(',') });
      })
      .then(fetchCart)
      .then(function (cart) {
        renderCart(cart);
        window.location.reload();
      })
      .catch(function () {
        showMessage(panel, 'The code could not be removed.');
      })
      .finally(function () {
        busy = false;
        panel.classList.remove('is-loading');
      });
  }

  function bindMobileEvents(root) {
    root.addEventListener('click', function (event) {
      if (!event.target.closest) return;

      var toggle = event.target.closest('[data-tw-mobile-coupon-toggle]');
      if (toggle) {
        event.preventDefault();
        var panel = root.querySelector('[data-tw-mobile-coupon]');
        setOpen(root, !(panel && panel.classList.contains('is-open')));
        return;
      }

      var apply = event.target.closest('[data-tw-mobile-coupon-apply]');
      if (apply) {
        event.preventDefault();
        var applyPanel = apply.closest('[data-tw-mobile-coupon]');
        if (applyPanel) applyCoupon(applyPanel);
        return;
      }

      var remove = event.target.closest('[data-tw-mobile-code-remove]');
      if (remove) {
        event.preventDefault();
        var removePanel = remove.closest('[data-tw-mobile-coupon]');
        if (removePanel) removeCoupon(removePanel, remove.getAttribute('data-tw-mobile-code-remove'));
      }
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' || !event.target.closest) return;
      var input = event.target.closest('[data-tw-mobile-coupon-input]');
      if (!input) return;
      event.preventDefault();
      var panel = input.closest('[data-tw-mobile-coupon]');
      if (panel) applyCoupon(panel);
    });
  }

  function initMobileToolbar() {
    var root = cartRoot();
    if (!root) return;

    installMobileStyles();
    createMobileUI(root);
    bindMobileEvents(root);
    syncCart();

    if (window.MinimogEvents && window.MinimogTheme) {
      var events = window.MinimogTheme.pubSubEvents || {};
      if (events.cartUpdate) window.MinimogEvents.subscribe(events.cartUpdate, syncCart);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileToolbar);
  } else {
    initMobileToolbar();
  }

  window.addEventListener('pageshow', syncCart);
})();
